import { useMutation } from '@tanstack/react-query';
import { toolsServices } from '../../../Domain/Tools/Services';

const mutationFn = (data: File) => {
  return toolsServices.uploadNaverrekenenTemplate(data);
};

export const useUploadNaverrekenenTemplateMutation = () => {
  return useMutation<unknown, unknown, File>(mutationFn);
};
